import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";

function PastPerformancePage() {
  return (
    <div className="min-h-screen bg-white text-black">
      <Navbar />
      <main>
        <section className="page-hero">
          <div className="container">
            <span className="eyebrow">
              Past Performance | Government Experience
            </span>
            <h1>Relevant experience and program impact</h1>
            <div>
              ThoughtCodes delivers measurable results across federal and
              mission-driven programs by modernizing systems, improving
              operational efficiency, and enabling secure, scalable digital
              transformation. Our experience spans application development,
              enterprise architecture, DevSecOps, and workflow automation in
              high-accountability environments.
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container table-like">
            <div className="row-item stat stat-interactive">
              <strong>DHS/ICE</strong>
              <div>
                <h3>Workflow modernization</h3>
                <div>
                  ThoughtCodes modernized HR operations by designing and
                  implementing a dynamic, workflow-driven system that
                  streamlined administrative processes, reduced manual effort,
                  and improved processing efficiency. Our solution enhanced user
                  experience through intuitive interfaces and automated task
                  routing, enabling faster decision-making and improved
                  transparency across HR functions. The modernization effort
                  resulted in reduced processing time, improved data accuracy,
                  and increased operational visibility.
                </div>
              </div>
            </div>
            <div className="row-item stat stat-interactive">
              <strong>DOD/DLA</strong>
              <div>
                <h3>Architecture and modernization support</h3>
                <div>
                  ThoughtCodes supported enterprise architecture and system
                  design activities aligned with DoDAF and federal architecture
                  frameworks, contributing to defense business transformation
                  and modernization initiatives. Our team provided system
                  engineering expertise, architecture modeling, and integration
                  support to improve interoperability, data consistency, and
                  system performance. This effort strengthened compliance,
                  enhanced transparency, and supported strategic decision-making
                  across mission-critical programs.
                </div>
              </div>
            </div>
            <div className="row-item stat stat-interactive">
              <strong>Department of Labor</strong>
              <div>
                <h3>API and data access enablement</h3>
                <div>
                  ThoughtCodes helped support access to diverse datasets in
                  preferred formats such as SDK, XML, and JSON using REST API
                  services. Our API-driven approach enabled secure, standardized
                  access to diverse datasets, supporting mission-critical
                  operations and enabling data-driven decision making across
                  government and mission-driven programs. The implementation
                  improved data integration, reduced latency, and enhanced
                  operational efficiency by enabling real-time data access and
                  analytics.
                </div>
              </div>
            </div>
            <div className="row-item stat stat-interactive">
              <strong>USAID / BHA</strong>
              <div>
                <h3>Digital Platform Development & Innovation</h3>
                <div>
                  ThoughtCodes supported the development of digital platforms to
                  connect global stakeholders and improve coordination for
                  humanitarian assistance initiatives. The solution enhanced
                  collaboration, streamlined communication, and provided
                  scalable tools to support real-time engagement and data
                  sharing across geographically distributed users.
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section soft gradient-bg">
          <div className="container">
            <div className="section-head center !max-w-[860px]">
              <div className="tag mb-3 !text-2xl">
                Supporting Federal Teams with Clear, Actionable Solutions
              </div>
              <div className="px-10">
                ThoughtCodes delivers concise, mission-aligned solutions that
                help agencies, program teams, and partners quickly understand
                capabilities, experience, and measurable outcomes. Our approach focuses on clarity, transparency, and technical
                alignment - ensuring stakeholders can confidently evaluate
                solutions that support modernization, security, and mission
                success.
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default PastPerformancePage;
